import React, {useEffect, useState} from 'react';
import {addIdToHash, removeIdFromHash, saveCheck} from '../../functions/Global';
import CustomDialog, {CustomDialogHeaderType} from '../../global/CustomDialog';
import {t} from 'i18next';
import {Button} from 'primereact/button';
import {UtilisationEditForm} from './UtilisationEditForm';
import {resetMappings} from '../../../redux/slices/MappingSlice';
import {useAppDispatch} from '../../../redux/hooks';
import {useTranslation} from 'react-i18next';
import {Utilisation} from '../../functions/ProjectMasterData';

type Props = {
    projectId: string,
    onFinished?: (success: any) => void,
    selectedUtil?: Utilisation,
    setSelectedUtil?: any,
    show?: boolean,
    setShow?: (data: boolean) => void,
}
export const UtilisationDialogEditForm = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common']);

    const formName = 'editPersonForm';
    const dispatch = useAppDispatch();

    const [isDirty, setIsDirty] = useState<boolean>(false);
    const [buttons, setButtons] = useState<any[]>([]);
    const [close, setClose] = useState<boolean>(false);

    useEffect(() => {
        if (props.selectedUtil) {
            addIdToHash(props.selectedUtil.inanspruchnahme_id);
        }
    }, [props.selectedUtil]);

    useEffect(() => {
        setButtons(getButtons());
    }, [isDirty]);

    const getButtons = () => {
        let result: any[] = [];

        let items: any[] = [];

        // items.push({
        //     label: t('globalData:process.create'),
        //     icon: 'pi pi-plus',
        //     command: () => {
        //         if (isDirty) {
        //             showMessageOnError(t('globalData:toasts.saveDataFirstHeader'), t('globalData:toasts.saveDataFirstMessage'));
        //             return;
        //         }
        //         setCreateNew(true);
        //     }
        // });
        //
        // items.push({
        //     label: t('globalData:process.duplicate'),
        //     icon: 'pi pi-copy',
        //     command: () => {
        //         if (isDirty) {
        //             showMessageOnError(t('globalData:toasts.saveDataFirstHeader'), t('globalData:toasts.saveDataFirstMessage'));
        //             return;
        //         }
        //
        //         setDuplicateNew(true);
        //     }
        // });
        //
        // items.push({
        //     label: t('globalData:process.landesgeoportalLink'),
        //     icon: 'pi pi-external-link',
        //     command: () => {
        //         window.open('');
        //     }
        // });
        //
        // items.push({
        //     label: t('globalData:process.borisLink'),
        //     icon: 'pi pi-external-link',
        //     command: () => {
        //     }
        // });

        // result.push(<>
        //     <Menu model={items} popup ref={menu} id="popup_menu"/>
        //     <Button className={'p-button-text'} label={t('options')} icon="pi pi-bars"
        //             onClick={(event) => menu.current.toggle(event)}
        //             aria-controls="popup_menu" aria-haspopup/>
        // </>);

        return result;
    };

    const onCancel = () => {
        dispatch(resetMappings());
        if (props.setSelectedUtil) props.setSelectedUtil(undefined);
        if (props.setShow) props.setShow(false);
        removeIdFromHash();
    };

    return (
        <CustomDialog
            className={'edit-dialog'}
            header={t('projectMasterData:utilisation.edit')}
            headerType={CustomDialogHeaderType.Update}
            onCancel={() => {
                if (isDirty) {
                    saveCheck(t, onCancel);
                } else {
                    onCancel();
                }

            }}
            visible={typeof props.show === 'boolean' ? props.show : false}
            customButtons={buttons}
            customButtonsBefore={true}
            maximized={true}
            buttonsInHeader={true}
            showFooter={true}
            formName={formName}
            onClickWithClose={() => {
                setClose(true);
            }}>
            <UtilisationEditForm id={formName} data={props.selectedUtil}
                                 setIsDirty={setIsDirty}
                                 onFinished={(data) => {
                                     dispatch(resetMappings());
                                     if (props.setShow) {
                                         props.setShow(false);
                                     }
                                     if (props.setSelectedUtil) {
                                         props.setSelectedUtil(undefined);
                                     }
                                     if (props.onFinished) {
                                         props.onFinished(data);
                                         removeIdFromHash();
                                     }
                                 }} projectId={props.projectId}/></CustomDialog>
    );
};
